import React, { useState, useEffect, useCallback } from 'react';
import {Modal, Input, Typography, message} from 'antd';
import {validateMarkingForProduct} from "../../utils/markingCodeParser";

const { Title, Text } = Typography;

const MarkingCodeModal = ({ visible, onCancel, onSubmit, productName, productBarcode }) => {
    const [markCode, setMarkCode] = useState('');
    const [barcodeBuffer, setBarcodeBuffer] = useState('');
    const [lastKeystroke, setLastKeystroke] = useState(0);
    const isElectron = Boolean(window?.process?.versions?.electron);

    const handleKeyDown = useCallback((e) => {
        if (!visible) return;
        if (document.activeElement && document.activeElement.tagName === 'INPUT') return;

        const currentTime = Date.now();
        const timeDiff = currentTime - lastKeystroke;

        if (timeDiff > 200) {
            setBarcodeBuffer('');
        }

        setLastKeystroke(currentTime);

        if (e.keyCode === 13 || e.keyCode === 10 || e.key === 'Enter') {
            if (barcodeBuffer.length >= 29) {
                // Проверяем соответствие маркировки штрихкоду товара
                if (productBarcode && !validateMarkingForProduct(barcodeBuffer, productBarcode)) {
                    message.error('Код маркировки не соответствует товару');
                    setBarcodeBuffer('');
                    e.preventDefault();
                    return;
                }
                onSubmit(barcodeBuffer);
            }
            setBarcodeBuffer('');
            e.preventDefault();
        } else if (e.key.length === 1) {
            setBarcodeBuffer(prev => prev + e.key);
            e.preventDefault();
        }
    }, [visible, barcodeBuffer, lastKeystroke, onSubmit, productBarcode]);

    useEffect(() => {
        if (visible) {
            window.addEventListener('keydown', handleKeyDown, true);
            return () => {
                window.removeEventListener('keydown', handleKeyDown, true);
            };
        }
    }, [visible, handleKeyDown]);

    useEffect(() => {
        if (!visible) {
            setMarkCode('');
            setBarcodeBuffer('');
        }
    }, [visible]);

    const handleSubmit = () => {
        const code = markCode.trim();
        if (code) {
            // Проверяем соответствие маркировки штрихкоду товара
            if (productBarcode && !validateMarkingForProduct(code, productBarcode)) {
                message.error('Код маркировки не соответствует товару');
                return;
            }
            onSubmit(code);
            setMarkCode('');
        }
    };

    return (
        <Modal
            open={visible}
            onCancel={onCancel}
            footer={null}
            width={500}
            centered
            closable
        >
            <div style={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                textAlign: 'center'
            }}>
                <Title level={3} style={{marginBottom: 16}}>
                    Отсканируйте код маркировки
                </Title>
                <div style={{textAlign: 'center', marginBottom: 12}}>
                    <svg width="127" height="120" viewBox="0 0 454 345" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M57.4447 0.374752L113 0V16.8739L65.8893 17.2487V61.3476H49V8.81168C49 4.16783 52.7966 0.374752 57.4447 0.374752ZM65.8893 283.402V327.501H112.5V344.375H57.4447C52.7966 344.375 49 340.617 49 335.938V283.402H65.8893Z"
                            fill="#5C5B5B"/>
                        <path
                            d="M396.555 0.749344L341 0.375V17.2305L388.111 17.6049V61.6558H405V9.17709C405 4.5383 401.203 0.749344 396.555 0.749344ZM388.111 283.468V327.519H341.5V344.375H396.555C401.203 344.375 405 340.621 405 335.947V283.468H388.111Z"
                            fill="#5C5B5B"/>
                        <path
                            d="M113 263.575H341V286.375H113V263.575ZM272.6 240.775H318.2V263.575H272.6V240.775ZM113 240.775H135.8V263.575H113V240.775ZM295.4 217.975H341V240.775H295.4V217.975ZM249.8 217.975H272.6V240.775H249.8V217.975ZM181.4 217.975H204.2V240.775H181.4V217.975ZM113 217.975H135.8V240.775H113V217.975ZM249.8 195.175H295.4V217.975H249.8V195.175ZM113 195.175H227V217.975H113V195.175ZM318.2 172.375H341V195.175H318.2V172.375ZM272.6 172.375H295.4V195.175H272.6V172.375ZM227 172.375H249.8V195.175H227V172.375ZM113 172.375H158.6V195.175H113V172.375ZM113 149.575H249.8V172.375H113V149.575ZM318.2 126.775H341V149.575H318.2V126.775ZM227 126.775H295.4V149.575H227V126.775ZM113 126.775H204.2V149.575H113V126.775ZM272.6 103.975H295.4V126.775H272.6V103.975ZM113 103.975H181.4V126.775H113V103.975ZM227 81.175H341V103.975H227V81.175ZM113 81.175H135.8V103.975H113V81.175ZM295.4 58.375H318.2V81.175H295.4V58.375ZM249.8 58.375H272.6V81.175H249.8V58.375ZM204.2 58.375H227V81.175H204.2V58.375ZM158.6 58.375H181.4V81.175H158.6V58.375ZM113 58.375H135.8V81.175H113V58.375Z"
                            fill="#5C5B5B"/>
                        <path d="M0 175.375H454" stroke="#EB0000" strokeOpacity="0.5" strokeWidth="21"/>
                    </svg>
                </div>

                <Text style={{marginBottom: 12, fontSize: '16px'}}>
                    Без кода нельзя добавить маркированный товар в чек – это требование закона
                </Text>


                {!isElectron && (
                    <Input
                        placeholder="Отсканируйте или введите код маркировки"
                        value={markCode}
                        onChange={(e) => setMarkCode(e.target.value)}
                        onPressEnter={handleSubmit}
                        autoFocus
                        size="large"
                    />
                )}

            </div>
        </Modal>
);
};

export default MarkingCodeModal;